function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import BotonNavegacion from './boton-navegacion';
import Miniatura from './miniatura';

var AreaMiniaturas = function (_Component) {
  _inherits(AreaMiniaturas, _Component);

  function AreaMiniaturas(props) {
    _classCallCheck(this, AreaMiniaturas);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleResize = function () {
      var miniatura = document.getElementsByClassName('miniatura activa')[0];

      if (!miniatura) {
        return;
      } // const r1 = miniatura.getBoundingClientRect();


      var r2 = miniatura.parentNode.getBoundingClientRect();
      var r3 = miniatura.parentNode.parentNode.getBoundingClientRect();
      var minOffset = -(r2.width - r3.width);

      if (minOffset > 0) {
        if (_this.state.minOffset !== 0 || _this.state.offset !== 0) {
          _this.setState({
            minOffset: 0,
            offset: 0
          });
        }
      } else {
        if (minOffset !== _this.state.minOffset) {
          _this.setState({
            minOffset: minOffset
          });
        }
      }
    };

    _this.handleDragStop = function (e, data) {
      _this.setState({
        dragging: false
      });
    };

    _this.handleDerecha = function () {
      _this.setState(function (prevState) {
        var miniatura = document.getElementsByClassName('miniatura activa')[0];
        var r1 = miniatura.getBoundingClientRect();
        var newOffset = prevState.offset - r1.width - 3;
        return {
          offset: newOffset > prevState.minOffset ? newOffset : prevState.minOffset
        };
      });
    };

    _this.handleIzquierda = function () {
      _this.setState(function (prevState) {
        var miniatura = document.getElementsByClassName('miniatura activa')[0];
        var r1 = miniatura.getBoundingClientRect();
        var newOffset = prevState.offset + r1.width + 3;
        return {
          offset: newOffset > 0 ? 0 : newOffset
        };
      });
    };

    _this.calcularOffset = function () {
      var miniatura = document.getElementsByClassName('miniatura activa')[0];

      if (!miniatura) {
        return;
      }

      var r1 = miniatura.getBoundingClientRect();
      var r2 = miniatura.parentNode.getBoundingClientRect();
      var r3 = miniatura.parentNode.parentNode.getBoundingClientRect();
      var offset = Math.min(0, r2.x + r3.width - (r1.x + r1.width + 3));

      if (_this.state.offset !== offset) {
        _this.setState({
          offset: offset
        });
      }
    };

    _this.handleOnMinitura = function (vineta) {
      if (_this.state.dragging) {
        _this.setState({
          dragging: false
        });

        return;
      }

      _this.props.onBoton(vineta.vinculo);
    };

    _this.handleMiniaturaReady = function () {
      _this.setState(function (prevState, props) {
        return {
          numMiniaturasReady: prevState.numMiniaturasReady + 1
        };
      }, function () {
        var numMiniaturas = _this.props.vinetas.length;

        if (_this.state.numMiniaturasReady === numMiniaturas) {
          _this.calcularOffset();

          _this.handleResize();
        }
      });
    };

    _this.state = {
      offset: 0,
      minOffset: 0,
      dragging: false,
      numMiniaturasReady: 0
    };
    return _this;
  }

  AreaMiniaturas.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    this.calcularOffset();
    this.handleResize();
  };

  AreaMiniaturas.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  };

  AreaMiniaturas.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.paso !== this.props.paso) {
      this.calcularOffset();
      this.handleResize();
    }

    if (prevProps.vinetas !== this.props.vinetas && this.state.numMiniaturasReady !== 0) {
      this.setState({
        numMiniaturasReady: 0
      });
    }
  };

  AreaMiniaturas.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        vinetas = _props.vinetas,
        paso = _props.paso;
    return React.createElement('div', {
      className: 'areaMiniaturasVisorImagenes'
    }, React.createElement('div', {
      className: 'controlMiniaturasVisorImagenes'
    }, React.createElement(BotonNavegacion, {
      activo: this.state.offset < 0,
      onPulsar: this.handleIzquierda,
      direccion: 'izquierda'
    })), React.createElement('div', {
      className: 'cajaMiniaturas'
    }, React.createElement('div', {
      className: 'deslizadorMiniaturas',
      style: {
        left: this.state.offset
      }
    }, vinetas.map(function (vineta, index) {
      return React.createElement(Miniatura, {
        key: vineta.src,
        vineta: vineta,
        actual: paso === index + 1,
        onPulsar: _this2.handleOnMinitura,
        onReady: _this2.handleMiniaturaReady
      });
    }))), React.createElement('div', {
      className: 'controlMiniaturasVisorImagenes'
    }, React.createElement(BotonNavegacion, {
      activo: this.state.offset > this.state.minOffset,
      onPulsar: this.handleDerecha,
      direccion: 'derecha'
    })));
  };

  return AreaMiniaturas;
}(Component);

AreaMiniaturas.propTypes = process.env.NODE_ENV !== "production" ? {
  paso: t.number.isRequired,
  vinetas: t.array.isRequired,
  onBoton: t.func.isRequired
} : {};
export default AreaMiniaturas;